import emojiIcon from './components'
const install = (Vue) => {
  Vue.component('emojiIcon', emojiIcon)
}

export default install



// WEBPACK FOOTER //
// ./src/plugins/index.js